<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0">
      <v-row>
        <v-col md="12">
          <div class="d-flex flex-wrap float-right" style="gap: 10px">
            <v-btn v-if="!userLimit" class="add-course-button" @click.prevent="showCreatePanel" outlined>
              Add User
            </v-btn>
            <v-btn v-else class="add-course-button" disabled @click.prevent="showCreatePanel" outlined>
              Add User
            </v-btn>
            <ImportUsersHR :name="hrPlatformName" v-if="isHRIntegrationEnabled && hrPlatformName != 'SenseHr'" />
            <ImportUsers v-else-if="!isHRIntegrationEnabled || hrPlatformName == 'SenseHr' " />
            <v-btn class="add-course-button" color="primary" @click.prevent="exportCsv('csv')" outlined>
              Export Users
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row v-if="userLimit">
        <v-col md="12">
          <v-alert type="error">You have reached the maximum number of users for your plan</v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="Full-Course-Library-Title"> User Management </v-col>
      </v-row>
      <v-row style="margin-top: 20px">
        <v-col cols="12" sm="4">
          <v-card flat style="background-color: transparent">
            <v-card-actions>
              <v-text-field style="margin-top: 2px !important" class="search-box" placeholder="Search Users By Name Or Email"
                prepend-icon="fa-search" v-model="search" type="text" clearable clear-icon="fa-times"
                @click:clear="resetSearch" @keyup="applySearch"></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card flat style="background-color: transparent">
            <v-card-actions>
              <v-select :items="allGroups" :clearable="true" item-text="name" item-value="id"
                placeholder="Select Groups" multiple small-chips class="groups"
                v-on:change="filterUsersByGroups($event)" attach></v-select>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="sm-mt-20">
        <v-col cols="12" sm="4">
          <v-select v-model="selectedMailOption" :items="mailOption" :clearable="true" item-text="text"
            item-value="value" placeholder="Select Option" persistent-hint
            hint="To send the Welcome Email please select an option to whom you would like to receive. " small-chips
            class="mail-option groups" v-on:change="changeMailOption($event)" attach></v-select>
        </v-col>
        <v-col cols="12" sm="7" class="sm-mt-40">
          <v-btn :disabled="!mailOptionSelected" class="welcome-email-button add-course-button"
            @click.prevent="sendWelcomeEmailToUsers" outlined>
            Send welcome email
          </v-btn>
        </v-col>
      </v-row>
      <v-row style="margin-top: 55px" no-gutters>
        <v-col :cols="12">
          <v-card flat>
            <h3>Current Users: {{ serverItemsLength }} / {{ maxUsers }}</h3>
          </v-card>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table v-model="selectedUsersForMail" :headers="computedHeaders" :options.sync="options"
              :server-items-length="serverItemsLength" :items="users" show-select class="mt-3"
              :footer-props="{
                'items-per-page-options': [5, 10, 15, 25 ,50 ,75, 100],
              }"  v-show="!loading" >
              <template v-slot:item.confirmed="{ item }">
                <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
                <v-icon v-else color="error">fa-times</v-icon>
              </template>
              <template v-slot:item.total_published_courses="{ item }">
                <span v-if="item.total_published_courses" class="clickable-count"
                  @click.stop="openDialog($event,buildCourseStatus(item),'Courses')">{{ item.total_published_courses
                  }}</span>
                <span v-else>{{ item.total_published_courses }}</span>
              </template>
              <template v-slot:item.total_groups="{ item }">
                <span v-if="item.total_groups" class="clickable-count"
                  @click.stop="openDialog($event,item.groups,'Groups')">{{ item.total_groups }}</span>
                <span v-else>{{ item.total_groups }}</span>
              </template>
              <template v-slot:item.total_channels="{ item }">
                <span v-if="item.total_channels" class="clickable-count"
                  @click.stop="openDialog($event,item.channels,'Playlists')">{{ item.total_channels }}</span>
                <span v-else>{{ item.total_channels }}</span>
              </template>
               <template v-slot:item.site_name="{ item }">
                <span v-if="item.site_name" class="clickable-count"
                  @click.stop="openDialog($event,item.site_name,`${$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`)">{{ item.site_name.length }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:item.id="{ item }">
                <v-select v-if="screenSize === 'tablet' || screenSize === 'mobile'" v-model="selectedAction"
                  :items="getActionList(item)" item-text="name" item-value="id" placeholder="Select Action"
                  @change="performAction(item)" :item-disabled="action => action.not_allow"></v-select>
                <template v-else>
                <v-tooltip v-if="!item.is_mail_sent" bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="primary" class="mr-1" text small
                      @click.prevent="sendWelcomeEmail(item.id)">
                      <v-icon small>fa-paper-plane</v-icon>
                    </v-btn>
                  </template>
                  <span>Send Welcome Email</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-if="item.id != authenticatedUser" v-slot:activator="{ on }">
                    <v-btn v-on="on" outlined small class="mr-1 action-button action-button-txt"
                      @click.prevent="archiveUser(item.id)">
                      <span>Archive</span>
                    </v-btn>
                  </template>
                  <span>Archive User</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn :id="item.id" v-on="on" outlined small class="mr-1 action-button action-button-txt"
                      @click.prevent="showEditPanel(item.id)">
                      <span>Edit User</span>
                    </v-btn>
                  </template>
                  <span>Edit User</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                      <v-btn
                      v-on="on"
                      outlined
                      small
                      class="mr-1 action-button action-button-txt"
                      :to="'/admin/user-report/'+item.id" 
                      >
                          <span>Report</span>
                      </v-btn>
                  </template>
                  <span>View courses report for this user</span>
                </v-tooltip>
                </template>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- Dialog -->
      <DialogComponent :isOpen="dialog" :dialogTitle="dialogTitle" :dialogData="dialogData" @close="closeDialog" />
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import userAPI from '@/api/user.js';
import companyAPI from '@/api/company.js';
import ImportUsersHR from '@/components/admin/users/ImportUsersHR';
import ImportUsers from '@/components/admin/users/ImportUsers';
import LayoutBasic from '@/layouts/Dashboard';
import EditUser from '@/components/admin/users/Edit';
import CreateUser from '@/components/admin/users/Create';
import ViewDetails from '@/components/admin/users/View';
import DialogComponent from '@/components/Dialog';
import { screensize } from '../../utils/screensize';

// Call the screensize function to get the screen size function
const getCurrentScreenSize = screensize();
const currentScreenSize = getCurrentScreenSize();

export default {
  name: 'UsersAdmin',
  components: {
    LayoutBasic,
    ImportUsers,
    ImportUsersHR,
    DialogComponent
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.handleResize);
    this.screenSize = null;
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Role Access', value: 'role_name'},
        { text: 'Last Login', value: 'last_login'},
        { text: 'Courses', value: 'total_published_courses', sortable: false },
        { text: 'Groups', value: 'total_groups', sortable: false },
        { text: 'Playlists', value: 'total_channels', sortable: false },
        { text: '', value: 'id', align: 'end', sortable: false },
      ],
      users: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      enableMail: '',
      confirmArchive: 'Are you sure you wish to archive this user?',
      opens: 'center',
      isClearButtonVisible: false,
      allGroups: [],
      filterGroups: '',
      mailOption: [
        { text: 'Send Welcome Email to all users', value: 1 },
        {
          text: 'Send Welcome Email to all new or outstanding users',
          value: 2,
        },
        { text: 'Send Welcome Email to selected users only', value: 3 },
        { text: 'Send Welcome Email to never logged in users', value: 4}
      ],
      mailOptionSelected: false,
      selectedMailOption: null,
      selectedUsersForMail: [],
      warningMessage: 'Please select users to send a welcome email.',
      successMessage: 'Welcome email sent successfully.',
      errorMessage: 'Oops, something went wrong!',
      archivedUserMessage:
        'You cannot archive this company admin as they were created by a partner.',
      updateRoleErrorMessage:
        'You cannot change role of admin User as they were created by a partner.',
      timer: null,
      isHRIntegrationEnabled: false,
      hrPlatformName: '',
      locations: [],
      dialog: false,
      dialogTitle : '',
      dialogData: [],
      selectedAction: null,
      screenSize: currentScreenSize,
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.locations.length) {
        headers.splice(8, 0, { text: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`, value: 'site_name', sortable: false });
      }
      return headers;
    },
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    maxUsers: function () {
      return this.$store.getters.maxUsers;
    },
    userLimit: function () {
      return this.serverItemsLength >= this.maxUsers ? true : false;
    },
    authenticatedUser: function () {
      return this.$store.getters.user.id;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    EventBus.$off('USERS_UPDATED');
    this.setEventBus();
    this.getCompany();
    this.getCompanySites();
    //this.$vuetify.theme.themes.light.grass = '#1976D2';
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
  },
  methods: {
    getUsers() {
      this.loading = true;
      userAPI.getClients(this.params, this.searchParams).then((resp) => {
        this.users = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    resetSearch() {
      this.search = '';
      this.options.page = 1;
      this.createSearchParams();
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        // if(payload)
        //   this.params = payload;
        
        this.getUsers();
      });
      EventBus.$on('USERS_ADDED', (payload) => {
        // this.params = payload;
        this.getUsers();
      });
    },
    applySearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.options.page = 1;
        this.createSearchParams();
      }, 1000);
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
          locations: this.locations
        },
        openOn: 'right',
      });
    },
    showDetailsPanel(id) {
      this.$showPanel({
        component: ViewDetails,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateUser,
        props: {
          params: this.params,
          locations: this.locations
        },
        openOn: 'right',
      });
    },
    enableDisableEmail(type) {
      this.loading = true;
      userAPI.enableDisableEmail(type).then((resp) => {
        this.enableMail = resp.data.data.enable_mail;
        this.loading = false;
      });
    },
    getCompany() {
      companyAPI
        .getCompanyById(
          this.$store.getters.user.company.data.id,
          '?include=groups'
        )
        .then((resp) => {
          this.enableMail = resp.data.data.enable_mail;
          this.allGroups = resp.data.data.groups.data;
          this.isHRIntegrationEnabled = resp.data.data.hr_config;
          this.hrPlatformName = resp.data.data.hr_platform;
        });
    },
    sendWelcomeEmail(id) {
      userAPI.sendWelcomeEmail(id).then(() => {
       this.$snotify.success('Your will receive the welcome email shortly.');
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        this.getUsers();
      });
    },
    archiveUser(id) {
      this.$snotify.confirm(this.confirmArchive, {
        backdrop: 0.3,
        buttons: [
          {
            text: 'Cancel',
            className: 'toast-cancel-button',
          },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processArchiveUser(toast, id),
          },
        ],
      });
    },
    processArchiveUser(toast, id) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      userAPI.archiveUser(id).then((resp) => {
        if (resp.status == 204) {
          this.$snotify.error(this.archivedUserMessage);
        } else {
          this.getUsers();
        }
        this.loading = false;
      });
    },
    filterUsersByGroups(data) {
      this.filterGroups = data.toString();
      this.createSearchParams();
    },
    createSearchParams() {
      this.searchParams = '';
      this.searchParams = this.params;
      if (this.search) {
        this.searchParams +=
          '&search=first_name:' + this.search + ';last_name:' + this.search+ ';email:' + this.search;
      }
      if (this.filterGroups) {
        this.searchParams += '&groups=' + this.filterGroups;
      }
      this.getUsers();
    },
    changeMailOption(option) {
      this.selectedMailOption = option;
      if (option) {
        this.mailOptionSelected = true;
      } else {
        this.mailOptionSelected = false;
      }
    },
    sendWelcomeEmailToUsers() {
      if (
        this.selectedMailOption == 3 &&
        this.processSelectedUsers().length == 0
      ) {
        this.$snotify.error(this.warningMessage);
        return true;
      }
      this.loading = true;
      userAPI
        .sendWelcomeEmailToUsers(
          this.selectedMailOption,
          this.processSelectedUsers()
        )
        .then(() => {
          this.successMessage =
            'Your welcome email request has been added to queue and will be processed shortly.';
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          this.selectedUsersForMail = [];
          this.changeMailOption(null);
          this.getUsers();
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    processSelectedUsers() {
      let members = [];
      this.selectedUsersForMail.forEach(function (x) {
        members.push(x.id);
      });
      return members;
    },
    exportCsv(type) {
      this.loading = true;
      let paramsSearched = '';
      if (this.search) {
        paramsSearched +=
          '&search=first_name:' + this.search + ';last_name:' + this.search+ ';email:' + this.search;
      }
      if (this.filterGroups) {
        paramsSearched += '&groups=' + this.filterGroups;
      }
      userAPI
        .exportUserCSV(
          '?limit=0' + paramsSearched,
          '&withArchive=1&skipPagination=true',
          '&type=' + type
        )
        .then((resp) => {
          window.open(resp.data);
          this.loading = false;
        });
    },
    getCompanySites() {
        companyAPI.getCompanySites().then(response => {
            this.locations = response.data.data;
        });
    },
    buildCourseStatus(user) {
      const completed = user.completed_courses || [];
      const inprogress = user.inprogress_courses || [];
      return (user.published_courses || []).map(name => ({
        name,
        state: completed.includes(name) ? 3 : inprogress.includes(name) ? 2 : 1
      }));
    },
    openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    },
    getActionList(item) {
      let actions = [
        {
          name: 'Send Welcome Email',
          action: () => this.sendWelcomeEmail(item.id),
          not_allow: item.is_mail_sent
        },
        { name: 'Archive', action: () => this.archiveUser(item.id), not_allow: item.id == this.authenticatedUser },
        {
          name: 'Edit User',
          action: () => this.showEditPanel(item.id)
        },
        {
          name: 'Report',
          action: () => this.$router.push(`/admin/user-report/${item.id}`)
        },
      ];

      return actions;
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },
     // Method to handle screen size changes
    handleResize() {
      this.screenSize = getCurrentScreenSize();
    },    
  },
};
</script>